import { TextInput, Text, Group, MantineTheme } from "@mantine/core";
import { createStyles } from "@mantine/emotion";
import type { CSSObject as CSS } from "@mantine/emotion";
import { ChangeEvent, FC } from "react";

type Props = {
  labelText: string;
  id?: string;
  placeHolder?: string;
  onChange?: CallableFunction;
  style?: CSS;
  isErrored?: string;
  errorMessage?: boolean;
  value: string;
  type?: string;
  readOnly?: boolean;
  disabled?: boolean;
  shorterLength?: boolean;
  max?: string;
  required?: boolean;
};

const InputGroup: FC<Props> = ({
  id,
  labelText,
  placeHolder,
  type = "text",
  value,
  isErrored,
  errorMessage,
  onChange,
  readOnly,
  disabled,
  shorterLength,
  max,
  required = false,
}) => {
  const useStyles = createStyles((theme: MantineTheme) => ({
    mainContainer: {},
    text: {
      paddingBottom: "0px",
      paddingLeft: "0px",
      color: "inherit",
      textAlign: "left",
      overflow: "visible",
    },
    text1: {
      paddingBottom: "0px",
      paddingLeft: "0px",
      color: "inherit",
      textAlign: "left",
      overflow: "visible",
      marginBottom: "22px",
    },
    inputField: {
      paddingTop: "2px",
      height: "45px",
      width: "100%",
      marginBottom: "10px",
      "& input": {
        border: isErrored ? `1px solid ${theme.colors.red[6]}` : undefined, // Apply error styling
      },
      '& input[type="date"]:not(:focus):invalid::-webkit-datetime-edit': {
        color: "transparent",
      },
      '& input[type="date"]:not(:focus):invalid::before': {
        content: '"dd/mm/yyyy"',
        color: theme.colors.gray[5],
        position: "absolute",
      },
    },
    errorMessage: {
      color: theme.colors.red[6],
      position: "relative",
      bottom: "10px",
      fontSize: "14px",
    },
    requiredAsterisk: {
      color: theme.colors.red[6],
    },
  }));
  const { classes } = useStyles();

  const OnChangeInput = (e: ChangeEvent<HTMLInputElement>) => {
    onChange?.(e.target.value);
  };

  return (
    <div className={classes.mainContainer}>
      <Group justify="flex-start" mb={5}>
        {!shorterLength && (
          <Text className={classes.text} component="label" htmlFor={id} size="sm">
            {labelText}
            {required && <span className={classes.requiredAsterisk}> *</span>}
          </Text>
        )}
        {shorterLength && (
          <Text className={classes.text1} component="label" htmlFor={id} size="sm">
            {labelText}
            {required && <span className={classes.requiredAsterisk}> *</span>}
          </Text>
        )}
      </Group>
      <TextInput
        id={id}
        type={type}
        placeholder={placeHolder}
        className={classes.inputField}
        value={value}
        size="md"
        onChange={OnChangeInput}
        readOnly={readOnly}
        disabled={disabled}
        max={max}
        required={required}
      />
      {isErrored && errorMessage && <div className={classes.errorMessage}>{isErrored}</div>}
    </div>
  );
};

export default InputGroup;
